import { HelpContent } from '../UI-Lib/Help-Tooltip';

export const CAP_RULE_HELP: HelpContent[] = [
    {
        helpContentId: 'cap-rule-details.delete',
        tooltipText: 'Delete'
    },
    {
        helpContentId: 'cap-rule-details.delete-disabled',
        tooltipText: 'Cannot delete the Cap Rule because of an active recalculation process'
    }
]
